import dayjs from 'dayjs';
import { isDayBetween } from '@ha/date';
import isDayExcluded from './isDayExcluded';
import isDayAfter from './isDayAfter';
import isDayBefore from './isDayBefore';

import calcFirstAvailableToDate from './calcFirstAvailableToDate';

import { DateSelectionRules, RangeModifier } from '../types';

const isToDateDisabled = (
  listingFlexibleDays: number,
  day: Date,
  from?: Date,
  exclusions: RangeModifier[] = [],
  minimumPeriod = 0,
  dateSelectionRules: DateSelectionRules = {},
): boolean => {
  const { minDate, maxDate } = dateSelectionRules;

  if (minDate && isDayBefore(day, new Date(minDate))) {
    return true;
  }

  if (maxDate && isDayAfter(day, new Date(maxDate))) {
    return true;
  }

  if (isDayExcluded(day, exclusions)) {
    return true;
  }

  // current day overlaps one of exclusions' periods
  const hasOverlap = exclusions.some(
    (excl: RangeModifier) =>
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      from && dayjs(day).isAfter(from) && isDayBetween(from, day, excl.from),
  );

  if (hasOverlap) {
    return true;
  }

  if (from && minimumPeriod) {
    const minimumAvailableDay = calcFirstAvailableToDate(
      from,
      minimumPeriod,
      listingFlexibleDays,
    );

    if (isDayBefore(day, minimumAvailableDay)) {
      return true;
    }
  }

  return false;
};

export default isToDateDisabled;
